import type { AnnouncementMessageType } from '@/apiClient/types/announcements'

import errorArt from './assets/error.webp'
import infoArt from './assets/info.webp'
import newFeatureArt from './assets/new-feature.webp'
import successArt from './assets/success.webp'
import warningArt from './assets/warning.webp'

export const ANNOUNCEMENT_HEADER_ILLUSTRATIONS: Partial<
  Record<AnnouncementMessageType, string>
> = {
  critical: errorArt,
  info: infoArt,
  new_feature: newFeatureArt,
  success: successArt,
  warning: warningArt,
}

export const getHeaderIllustration = (
  type: AnnouncementMessageType | null | undefined,
): string | undefined =>
  type ? ANNOUNCEMENT_HEADER_ILLUSTRATIONS[type] : undefined
